export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const EMPTY_SETTINGS = {
  openai: { has_api_key: false, key_preview: null },
  jira: { base_url: "", email: "", project_key: "" },
  github: { configured: false, connected: false, mappings: [] }
};

export const saveSettings = async (body, token) => {
  const res = await fetch(`${API_BASE_URL}/settings`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify(body)
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.detail || "Failed to save settings.");
  return data;
};

export const workspaceRequest = async (path, method, body, token) => {
  const res = await fetch(`${API_BASE_URL}${path}`, {
    method,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: body ? JSON.stringify(body) : undefined
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.detail || "Workspace request failed.");
  return data;
};

export const projectRequest = async (path, method, body, token) => {
  const res = await fetch(`${API_BASE_URL}${path}`, {
    method,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: body ? JSON.stringify(body) : undefined
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.detail || "Project request failed.");
  return data;
};

export const settingsRequest = async (path, method, body, token) => {
  const res = await fetch(`${API_BASE_URL}${path}`, {
    method,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: body ? JSON.stringify(body) : undefined
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.detail || "Settings request failed.");
  return data;
};

export const compareWorkstreams = (left, right) => (
  (left.priority_rank ?? 0) - (right.priority_rank ?? 0) || left.id - right.id
);
